import { getRedirectUrl, shopifyAuthOptions } from "../models";


interface AccessTokenResponse {
    access_token: string;
    expires_in: number;
    id_token: string;
    refresh_token: string;
}


/**
 * Exchanges the authorization code for an access token
 * This should be called server-side in a Gatsby page/route
 */
export const exchangeCodeForToken = async (
    code: string
): Promise<AccessTokenResponse> => {
    const redirectUri = getRedirectUrl(`/auth/callback`);
    const { shopId, clientId } = shopifyAuthOptions;

    // Get stored code verifier
    const codeVerifier = typeof window !== 'undefined'
        ? localStorage.getItem('code-verifier')
        : null;

    if (!codeVerifier) {
        throw new Error('Code verifier not found. Authentication flow may have been interrupted.');
    }

    // Prepare request body
    const body = new URLSearchParams();
    body.append('grant_type', 'authorization_code');
    body.append('client_id', clientId);
    body.append('redirect_uri', redirectUri);
    body.append('code', code);
    body.append('code_verifier', codeVerifier);

    // Make token exchange request
    const response = await fetch(
        `https://shopify.com/authentication/${shopId}/oauth/token`,
        {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                // 'user-agent': 'Blootropic-Website', // Required to prevent 403
                // 'origin': typeof window !== 'undefined' ? window.location.origin : '', // Required for token validation
            },
            body,
        }
    );

    if (!response.ok) {
        const error = await response.text();
        throw new Error(`Token exchange failed: ${error}`);
    }

    // Clear stored PKCE values
    if (typeof window !== 'undefined') {
        localStorage.removeItem('code-verifier');
        localStorage.removeItem('auth-state');
        localStorage.removeItem('auth-nonce');
    }

    return response.json();
};